function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { message, Button, Divider, Skeleton, Drawer, Tabs } from 'antd';
import { Table, Container, Row, Col } from 'react-bootstrap';
import Common from "../components/includes/Common";
import AudioForm from "../components/forms/AudioForm";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TabPane = Tabs.TabPane;
var ProcessAudio = function ProcessAudio() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    customers = _useState4[0],
    setCustomers = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isProcessDrawerVisible = _useState6[0],
    setIsProcessDrawerVisible = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedCustomer = _useState8[0],
    setSelectedCustomer = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    dataUpdated = _useState10[0],
    setDataUpdated = _useState10[1];
  var handleMedProcess = function handleMedProcess(c) {
    setSelectedCustomer(c);
    setIsProcessDrawerVisible(true);
  };
  var hpHandler = function hpHandler() {
    setIsProcessDrawerVisible(false);
    setDataUpdated(true);
    message.success({
      content: 'Données audio rempli avec succès',
      delay: 4
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    setDataUpdated(false);
    axios.get(Common.baseApiUrl + 'getaudioqueue/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCustomers(response.data.customers);
      } else {}
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataUpdated]);
  useEffect(function () {
    setInterval(function () {
      setDataUpdated(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Drawer, {
      title: "AUDIO FORM",
      visible: isProcessDrawerVisible,
      onClose: function onClose() {
        setIsProcessDrawerVisible(false);
      },
      destroyOnClose: true,
      width: "420",
      children: /*#__PURE__*/_jsx(AudioForm, {
        handler: hpHandler,
        candidat: selectedCustomer
      })
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 10,
          sm: 11,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsxs(Tabs, {
              defaultActiveKey: 1,
              children: [/*#__PURE__*/_jsxs(TabPane, {
                tab: "EN ATTENTE",
                children: [/*#__PURE__*/_jsx("h5", {
                  children: "FILE D'ATTENTE AUDIO-TEST"
                }), /*#__PURE__*/_jsx(Divider, {}), customers && /*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("th", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "RNC"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Pr\xE9nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "T\xE9l\xE9phone"
                      }), /*#__PURE__*/_jsx("th", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: customers.filter(function (cu) {
                      return cu.audioresult_id == null;
                    }).map(function (c) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(c.created_at).toLocaleDateString('Fr', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric'
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.rnc
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.mobile
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              handleMedProcess(c);
                            },
                            children: "Saisir"
                          })
                        })]
                      }, 'q' + c.id.toString());
                    })
                  })]
                }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              }, 1), /*#__PURE__*/_jsxs(TabPane, {
                tab: "TRAITE",
                children: [customers && /*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("th", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "RNC"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Pr\xE9nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "T\xE9l\xE9phone"
                      }), /*#__PURE__*/_jsx("th", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: customers.filter(function (cu) {
                      return cu.audioresult_id != null;
                    }).map(function (c) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(c.created_at).toLocaleDateString('Fr', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric'
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.rnc
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.mobile
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              handleMedProcess(c);
                            },
                            children: "Modifier"
                          })
                        })]
                      }, 'q' + c.id.toString());
                    })
                  })]
                }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              }, 2)]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 2,
          children: /*#__PURE__*/_jsx("img", {
            src: "drawables/aucheck.png",
            style: {
              width: '95%'
            }
          })
        })]
      })
    })]
  });
};
export default ProcessAudio;